import { Component, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { LocaleService } from '@next/core-lib/i18n';
import { Store } from '@ngrx/store';
import { hasValidInformation } from 'src/app/registration/store/selectors/information.selectors';

import { SiteState } from 'src/app/shared/models';

import { StorageTimeType } from '../../models/registration.model';
import { BatchConfigurationOutcomeService } from '../../services/batch-configuration-outcome.service';
import { selectBatches, hasBatches } from '../../store/selectors/batch.selectors';

@Component({
  selector: 'app-registration-batch-overview',
  templateUrl: './batch-overview.component.html',
  styleUrls: ['./batch-overview.component.scss'],
  standalone: false,
})
export class BatchOverviewComponent {
  private readonly store = inject<Store<SiteState>>(Store);
  private readonly locale = inject(LocaleService);
  readonly batchConfigurationOutcomeService = inject(BatchConfigurationOutcomeService);
  private readonly router = inject(Router);

  @Input() viewMode: boolean;

  hasValidInformationForm$ = this.store.select(hasValidInformation);
  batchesForm$ = this.store.select(selectBatches);
  hasBatches$ = this.store.select(hasBatches);
  StorageTimeType = StorageTimeType;

  getDeliveryName(storageTimeType: StorageTimeType) {
    return parseInt(String(storageTimeType), 10) === StorageTimeType.long
      ? this.locale.translate('batch-overview.storage-time-type-long')
      : parseInt(String(storageTimeType), 10) === StorageTimeType.short
        ? this.locale.translate('batch-overview.storage-time-type-short')
        : '';
  }

  addBatch() {
    this.router.navigate(['/registration', 'batches', 'add']);
  }
}
